export default __webpack_public_path__ + "static/EVENT_MARKER-c0714cbd99358ce8188c736b5b97d3ca.png";